import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7OPCVMCompositionsSchema = z.object({
  date_equals: z.string().optional(),
  denomination_fonds_contains: z.string().optional(),
  underlying_id_equals: z.string().optional(),
  denomination_du_sous_jacent_contains: z.string().optional(),
  file_id_equals: z.string().optional(),
});

export type FilterA7OPCVMCompositionsSchema = z.infer<
  typeof filterA7OPCVMCompositionsSchema
>;

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "denomination_fonds_contains",
    label: `Fonds`,
    type: "input",
  },
  {
    name: "underlying_id_equals",
    label: `Instrument financier`,
    type: "input",
  },
  {
    name: "denomination_du_sous_jacent_contains",
    label: `Émetteur`,
    type: "input",
  },
  {
    name: "file_id_equals",
    label: `Fichier`,
    type: "input",
  },
];

export function FilterA7OPCVMCompositions({
  table_name,
}: {
  table_name: string;
}) {
  const { fields } = useDateOptions("a7", table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7OPCVMCompositionsSchema}
      tableName="a7_opcvm_compositions"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
